// Components
import CountDownModal from "components/molecules/ModalContainer/CountDownModalContainer";

// Type Definitions
import type { RcFile } from "antd/es/upload/interface";

// Constants
import { FILE_UPLOAD_CONSTANT } from "constants/global";

export function useMultipleFileUpload(accept?: string) {
	const beforeUpload = (file: RcFile) => {
		const isLt5M = file.size / 1024 / 1024 < 5;
		const uploadedFileType = file.type === "" ? FILE_UPLOAD_CONSTANT.FILETYPE_MSG : `.${file.type?.substring(file.type.lastIndexOf("/") + 1)}`;
		const acceptFileTypeArray = accept?.split(",")?.map(function (item) {
			return item.trim();
		});
		const isAccepted = acceptFileTypeArray?.includes(uploadedFileType);

		if (!isLt5M || !isAccepted) {
			CountDownModal({
				timer: 3,
				title: !isLt5M ? FILE_UPLOAD_CONSTANT.MAXIMUM_FILE_LIMIT : FILE_UPLOAD_CONSTANT.UNSUPPORTED_FILE_TYPE,
				errorIcon: true
			});
		}

		return isLt5M && isAccepted;
	};

	return { beforeUpload };
}
